import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import Routes from './routes/routes.js';
import Amplify from 'aws-amplify';
import config from './config';

/*
 * This information is from AWS Cognito ResIntel-User-Pool. It builds
 * the login and signup pages and monitor authorization.
 * 
 * Run 'npm run start' to execute the application. Got to http://localhost:3000/ to view running application. 
 * Run 'npm run build' to create production build application. Then go to the 'build folder' and upload all the files in
 * the 'build folder' up to AWS S3 buckets 'res-intel-energize'.
 */
Amplify.configure({
    Auth: {
        mandatorySignIn: true,
        region: config.awsCognito.region,
        userPoolId: config.awsCognito.userPoolId,
        userPoolWebClientId: config.awsCognito.appClientId
    }
});

ReactDOM.render(
    <BrowserRouter>
        <nav className='navbar fixed-top navbar-light bg-white'>
            <div className="container-fluid">
                <div className="navbar-header">
                    <a className="navbar-brand" href="https://www.energize.fun/">
                        <img alt="Brand" src='/img/ENERGIZE.PNG' />
                    </a>
                </div>
            </div>
        </nav>
        <Routes />
    </BrowserRouter>,
    document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js